//#region src/v2/features/localization/locales/ar.ts
/** Built-in API Client translations for ar. */
var ar = {
	"serverVariablesSelect": { "selected": "المحدد:" },
	"serverVariablesTextbox": { "value": "قيمة" },
	"sidebarListElementForm": { "cancel": "إلغاء" },
	"requestBlock": {
		"authentication": "المصادقة",
		"variables": "المتغيرات",
		"cookies": "ملفات تعريف الارتباط",
		"headers": "الترويسات",
		"queryParameters": "معاملات الاستعلام",
		"queryString": "سلسلة الاستعلام",
		"queryStringDescription": "يوفر هذا المعامل سلسلة الاستعلام بأكملها، لذلك لا يمكن إضافة معاملات مسماة أخرى. تُرسل المعاملات المسماة الحالية بعده؛ وتُحفظ المفاتيح المكررة.",
		"requestBody": "جسم الطلب",
		"requestName": "اسم الطلب",
		"label": "الطلب: {name}"
	},
	"responseBlock": {
		"requestFailed": "فشل الطلب",
		"networkErrorHelp": "تشمل الأسباب المحتملة قيود CORS أو مشكلة في الاتصال بالشبكة. راجع وحدة تحكم المتصفح للحصول على التفاصيل. إذا كانت CORS تمنع الطلب، فاضبط خادم API للسماح بهذا المصدر أو استخدم وكيلاً موثوقاً.",
		"response": "الاستجابة",
		"requestHeaders": "ترويسات الطلب",
		"responseHeaders": "ترويسات الاستجابة",
		"body": "الجسم"
	},
	"codeInput": {
		"required": "مطلوب",
		"exitHint": "اضغط على {escape} ثم {tab} للخروج"
	},
	"codeInputLite": { "required": "مطلوب" },
	"dataTableInput": {
		"clearValue": "مسح القيمة",
		"resetValue": "إعادة التعيين إلى القيمة الافتراضية",
		"showPassword": "إظهار كلمة المرور",
		"hidePassword": "إخفاء كلمة المرور"
	},
	"dataTableInputSelect": {
		"value": "القيمة",
		"addValue": "إضافة قيمة"
	},
	"confirmationForm": {
		"cancel": "إلغاء",
		"save": "حفظ"
	},
	"collapsibleSection": {
		"collapsed": "(مطوي)",
		"item": "عنصر",
		"items": "عناصر"
	},
	"modalClientContainer": { "label": "عميل API" },
	"serverDropdown": {
		"server": "الخادم:",
		"addServer": "إضافة خادم",
		"updateServers": "تحديث الخوادم",
		"unknownServer": "خادم غير معروف"
	},
	"sidebar": { "search": "بحث" },
	"sidebarMenu": { "settings": "الإعدادات" },
	"sidebarToggle": {
		"hide": "إخفاء الشريط الجانبي",
		"show": "إظهار الشريط الجانبي"
	},
	"environmentsList": { "addEnvironment": "إضافة بيئة" },
	"modal": { "noDocumentSelected": "لم يتم تحديد مستند" },
	"operation": { "selectAnOperationToViewDetails": "حدد عملية لعرض التفاصيل" },
	"header": {
		"operationSettings": "إعدادات العملية",
		"closeClient": "إغلاق العميل"
	},
	"openApiClientButton": { "openAPIClient": "فتح عميل API" },
	"requestBody": {
		"noBody": "بدون جسم",
		"delete": "حذف",
		"selectFile": "اختيار ملف",
		"multipartForm": "نموذج متعدد الأجزاء",
		"formUrlEncoded": "نموذج بترميز URL",
		"binaryFile": "ملف ثنائي",
		"other": "آخر",
		"none": "لا شيء"
	},
	"requestBodyStructured": { "body": "الجسم" },
	"requestBodyViewToggle": {
		"schema": "المخطط",
		"form": "نموذج",
		"raw": "خام",
		"fixBody": "صحح الجسم للتبديل إلى عرض النموذج"
	},
	"requestCodeSnippet": {
		unavailable: "لا يوجد نموذج تعليمات برمجية متاح لهذا المثال.",
		"codeSnippet": "مقتطف برمجي"
	},
	"requestTable": {
		"enabled": "مفعّل",
		"key": "المفتاح",
		"value": "القيمة"
	},
	"requestTableRow": {
		"key": "المفتاح",
		"value": "القيمة",
		"delete": "حذف",
		"selectFile": "اختيار ملف",
		"globalCookieHint": "تتم مشاركة ملفات تعريف الارتباط العامة عبر مساحة العمل بأكملها. انقر للانتقال إليها.",
		"readOnlyHint": "هذه الخاصية للقراءة فقط. لتغييرها، يجب تجاوز قيمتها أو تعطيلها باستخدام مربع الاختيار.",
		"include": "تضمين {name} في الطلب",
		"keyLabel": "مفتاح {name}",
		"valueLabel": "قيمة {name}",
		"deleteRow": "حذف {name}",
		"row": "صف"
	},
	"requestTableTooltip": {
		"min": "الحد الأدنى:",
		"max": "الحد الأقصى:",
		"default": "الافتراضي:",
		"invalid": "الإدخال غير صالح",
		"moreInformation": "مزيد من المعلومات"
	},
	"headers": {
		"headerKey": "مفتاح الترويسة",
		"headerValue": "قيمة الترويسة",
		"noHeaders": "لا توجد ترويسات"
	},
	"responseBody": { "binaryFile": "ملف ثنائي" },
	"responseBodyPreview": { "previewUnavailable": "المعاينة غير متاحة" },
	"responseBodyStreaming": {
		"body": "الجسم",
		"listening": "جارٍ الاستماع…",
		"cancel": "إلغاء"
	},
	"responseBodyToggle": {
		"preview": "معاينة",
		"raw": "خام"
	},
	"responseBodyVirtual": {
		"body": "الجسم",
		"largeBodyHint": "جسم هذه الاستجابة كبير جدًا ولا يمكن تمييز بنيته البرمجية."
	},
	"responseCookies": {
		"cookies": "ملفات تعريف الارتباط",
		"cookieName": "اسم ملف تعريف الارتباط",
		"cookieValue": "قيمة ملف تعريف الارتباط",
		"noCookies": "لا توجد ملفات تعريف ارتباط"
	},
	"responseEmpty": {
		"roadmap": "خارطة الطريق",
		"poweredByScalarcom": "بدعم من Scalar.com",
		"getStarted": "البدء",
		"newRequest": "طلب جديد",
		"sendRequest": "إرسال الطلب",
		"version": "تطبيق Scalar V{version} التجريبي"
	},
	"responseLoadingOverlay": { "cancel": "إلغاء" },
	"addressBar": {
		"path": "المسار",
		"copyUrl": "نسخ الرابط",
		"send": "إرسال",
		"sendRequest": "إرسال طلب {method} إلى {url}",
		"duplicateRequest": "يوجد بالفعل طلب {method} إلى {path} في هذا المستند",
		"urlPlaceholder": "أدخل رابطًا",
		"webhookUrlPlaceholder": "أدخل رابط Webhook الكامل، مثل https://example.com/hook"
	},
	"addressBarHistory": { "requestHistory": "سجل الطلبات" },
	"environmentSelector": {
		"noEnvironment": "بدون بيئة",
		"notAvailableInThisContext": "غير متاح في هذا السياق",
		"environmentHint": "تتيح لك البيئات إدارة متغيرات مثل مفاتيح API والروابط الأساسية عبر سياقات مختلفة.",
		"add": "إضافة بيئة",
		"select": "اختيار بيئة",
		"unavailable": "{name} (غير متاح)",
		"current": "البيئة الحالية: {name}"
	},
	"deleteRequestAuthModal": {
		"deleteSecurityScheme": "حذف مخطط الأمان",
		"cancel": "إلغاء",
		"delete": "حذف",
		"confirmation": "لا يمكن التراجع عن هذا الإجراء. أنت على وشك حذف مخطط الأمان {name} من المجموعة."
	},
	"oauth2": {
		deviceAuthorizationUrl: "رابط تفويض الجهاز",
		deviceVerificationPrompt: "افتح صفحة التحقق وأدخل هذا الرمز:",
		waitingForAuthorization: "في انتظار التفويض…",
		cancelDeviceAuthorization: "إلغاء",
		"accessToken": "رمز الوصول",
		"refreshUrl": "رابط التجديد",
		"refresh": "تحديث",
		"authUrl": "رابط المصادقة",
		"tokenUrl": "رابط الرمز",
		"redirectUrl": "رابط إعادة التوجيه",
		"username": "اسم المستخدم",
		"password": "كلمة المرور",
		"clientID": "معرّف العميل",
		"clientSecret": "سر العميل",
		"usePKCE": "استخدام PKCE",
		"credentialsLocation": "موضع بيانات الاعتماد",
		"authorize": "تخويل",
		"clear": "مسح",
		"failedToauthorize": "فشل التخويل",
		"failedToRefreshToken": "فشل تجديد الرمز",
		"optionalRedirectUrl": "رابط إعادة توجيه اختياري",
		"clearTokens": "مسح الرموز",
		"resetDiscovery": "إعادة تعيين الاكتشاف"
	},
	"oauthScopesAddModal": {
		"name": "الاسم:",
		"description": "الوصف:",
		"readUserData": "قراءة بيانات المستخدم",
		"edit": "تعديل النطاق",
		"add": "إضافة نطاق",
		"save": "حفظ",
		"required": "اسم النطاق مطلوب.",
		"duplicate": "يوجد بالفعل نطاق باسم «{name}»."
	},
	"oauthScopesInput": {
		"noScopesDefined": "لم يتم تحديد نطاقات",
		"addScope": "إضافة نطاق",
		"deselectAll": "إلغاء تحديد الكل",
		"selectAll": "تحديد الكل",
		"selectedScopes": "النطاقات المحددة: {count} / {total}",
		"editScope": "تعديل {name}",
		"deleteScope": "حذف {name}",
		"selectScope": "تحديد النطاق {name}"
	},
	"openIdConnect": {
		"discoveryUrl": "رابط الاكتشاف",
		"fetchConfiguration": "جلب الإعدادات",
		"failedToFetchConfiguration": "فشل جلب إعدادات OpenID Connect"
	},
	"requestAuthDataTable": { "noauthenticationSelected": "لم يتم اختيار طريقة مصادقة" },
	"requestAuthTab": {
		"token": "الرمز",
		"bearerToken": "رمز Bearer",
		"getAToken": "الحصول على رمز",
		"refresh": "تحديث",
		"username": "اسم المستخدم",
		"password": "كلمة المرور",
		"name": "الاسم",
		"value": "القيمة",
		"cancel": "إلغاء",
		"authorize": "تخويل",
		"unsupportedCredentials": "لا يرسل عميل المتصفح بيانات الاعتماد لمخطط أمان AsyncAPI هذا.",
		"authorizeVia": "التخويل عبر {name}",
		"unsupportedType": "نوع مخطط الأمان {type} غير مدعوم بعد.",
		"missingType": "لم يتم تحديد نوع مخطط الأمان. تحقق من مستند {type} أو إعدادات المصادقة.",
		"failedToauthorize": "فشل التخويل",
		"failedToRefresh": "فشل التحديث",
		"configure": "إعداد {name}",
		"mutualTlsHint": "تستخدم مصادقة TLS المتبادلة شهادة عميل تُقدَّم أثناء مصافحة TLS، لذلك لا يلزم إدخال أي شيء هنا."
	},
	"commandActionForm": { "continue": "متابعة" },
	"environment": {
		"thisIsTheActiveEnvironment": "هذه هي البيئة النشطة",
		"active": "نشط",
		"editEnvironment": "تعديل البيئة",
		"deleteEnvironment": "حذف البيئة"
	},
	"environmentCreateModal": {
		"environmentName": "اسم البيئة",
		"thisEnvironmentNameIsAlreadyInUse": "اسم البيئة هذا مستخدم بالفعل.",
		"update": "تحديث البيئة",
		"add": "إضافة بيئة"
	},
	"environmentDeleteModal": {
		"cancel": "إلغاء",
		"deleteEnvironment": "حذف البيئة",
		"deleteConfirmation": "هل أنت متأكد من حذف هذه البيئة؟ لا يمكن التراجع عن هذا الإجراء.",
		"title": "حذف {name}"
	},
	"environmentVariablesDropdown": {
		"variableSuggestions": "اقتراحات المتغيرات",
		"addVariable": "إضافة متغير"
	},
	"environmentVariablesTable": {
		"name": "الاسم",
		"value": "القيمة",
		"actions": "الإجراءات",
		"environmentVariableName": "اسم متغير البيئة",
		"environmentVariableValue": "قيمة متغير البيئة"
	},
	"documentSearchModal": {
		"documentSearch": "البحث في المستند",
		"documentSearchResults": "نتائج البحث في المستند",
		"navigate": "↑↓ تنقّل",
		"select": "⏎ تحديد",
		"keyboardInstructions": "اضغط على السهم لأعلى أو لأسفل للتنقل، وعلى Enter للتحديد، واكتب لتصفية النتائج"
	},
	"searchResult": {
		"httpMethod": "طريقة HTTP:",
		"path": "المسار:",
		"description": "الوصف:",
		"heading": "عنوان",
		"operation": "عملية",
		"tag": "وسم"
	},
	"sectionFilter": {
		"all": "الكل",
		"auth": "المصادقة",
		"variables": "المتغيرات",
		"cookies": "ملفات تعريف الارتباط",
		"headers": "الترويسات",
		"query": "الاستعلام",
		"body": "الجسم"
	},
	"requestParams": {
		"addParameter": "إضافة معلمة",
		"searchParameters": "البحث عن المعلمات",
		"noParametersFound": "لا توجد معلمات مطابقة",
		"clearAll": "مسح الكل: {title}",
		"clear": "مسح",
		"clearOptionalParameters": "مسح المعاملات الاختيارية"
	},
	"responseBodyDownload": {
		"download": "تنزيل جسم الاستجابة",
		"label": "تنزيل",
		"body": "جسم الاستجابة"
	},
	"responseMetaInformation": {
		"duration": "معلومات الاستجابة، المدة:",
		"size": "، الحجم:",
		"status": "، الحالة:"
	},
	"authSelector": {
		"selectedType": "نوع المصادقة المحدد: {type}",
		"multipleTypes": "تم تحديد عدة أنواع مصادقة",
		"selectType": "اختيار نوع المصادقة",
		"optional": "اختياري",
		"required": "مطلوب",
		"deleteScheme": "حذف {name}",
		"requiredGroup": "المصادقة المطلوبة",
		"availableGroup": "المصادقة المتاحة",
		"addGroup": "إضافة مصادقة جديدة"
	},
	"operationBlock": {
		"webhookUrlRequired": "رابط Webhook مطلوب. أدخل وجهة أولًا.",
		"pathParametersRequired": "يجب أن تكون لمعاملات المسار قيم.",
		"forbiddenMethod": "لا يمكن لواجهة Fetch API إرسال طلبات {method}."
	},
	"dataTableCheckbox": { "toggle": "تبديل" },
	"pillTooltipHost": {
		"computedAtExecution": "تُحسب عند تنفيذ الطلب",
		"noValue": "لا توجد قيمة"
	},
	"authOptions": {
		oauth2DeviceAuthorization: "تفويض الجهاز عبر OAuth2",
		"apiKeyCookie": "مفتاح API في ملفات تعريف الارتباط",
		"apiKeyHeader": "مفتاح API في الترويسات",
		"apiKeyQuery": "مفتاح API في معاملات الاستعلام",
		"httpBasic": "HTTP Basic",
		"httpBearer": "HTTP Bearer",
		"oauth2Implicit": "التدفق الضمني لـ OAuth2",
		"oauth2Password": "تدفق كلمة المرور لـ OAuth2",
		"oauth2ClientCredentials": "بيانات اعتماد العميل لـ OAuth2",
		"oauth2AuthorizationFlow": "رمز تخويل OAuth2"
	},
	"deleteSidebarListElement": { "delete": "حذف {name}" },
	"deleteModal": { "delete": "حذف {name}" }
};
//#endregion
export { ar };

//# sourceMappingURL=ar.js.map